import { StyledTitle, text } from "@quickpoint.me/shared";
import { useRecoilValue } from "recoil";
import { UnprocessedIds } from "../../state/uploaderState";
import BrowseButton from "../BrowseButton";
import ToggleFilesPanelButton from "../ToggleFilesPanel";
import UploadFilesView from "../uploadFiles/UploadFilesView";
import FileTabs from "./Tabs";

function Nav({ $isInPortrait }: { $isInPortrait: boolean }) {
    const unprocessedIds = useRecoilValue(UnprocessedIds);
    const showUpload = unprocessedIds.length > 0;

    if (showUpload) {
        return <UploadFilesView $isInPortrait={$isInPortrait} />;
    }

    return (
        <>
            <StyledTitle $isInPortrait={$isInPortrait} className="title">
                <div role="heading" aria-level={2}>{text.fileUploader.title}</div>
                <ToggleFilesPanelButton />
            </StyledTitle>
            <FileTabs $isInPortrait={$isInPortrait} />
            <BrowseButton $isInPortrait={$isInPortrait} />
        </>
    );
}

export default Nav;
